import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'privacyPolicyLink',
  initialState: null as string | null,
  reducers: {
    setPrivacyPolicyLink(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setPrivacyPolicyLink } = slice.actions;
export default slice.reducer;
